var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomSearch = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26.822 22.958-4.609-4.606s-.048-.048-.096-.048a13.032 13.032 0 0 1-1.488 1.823 10.755 10.755 0 0 1-1.825 1.488s.048.048.048.096l4.61 4.605c.911.912 2.4.912 3.312 0 .96-.96.96-2.446.048-3.358z",
    fill: "#1E2969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.123 5.029a10.304 10.304 0 0 0-14.594 0 10.304 10.304 0 0 0 0 14.594 10.304 10.304 0 0 0 14.594 0c4.039-4.038 4.039-10.601 0-14.594zM7.411 17.696a7.617 7.617 0 0 1 0-10.785 7.617 7.617 0 0 1 10.785 0 7.617 7.617 0 0 1 0 10.785c-2.938 2.983-7.802 2.983-10.785 0z",
    fill: "#1B7690"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-search.148903506f7f94eae461fab9eb00a397.svg";